// Conversation tags — POST/DELETE /api/conversations/:id/tags
import { addConversationTagApi, removeConversationTagApi } from "../api/services/conversationService";

export const addConversationTag = async (conversationId, tag) => {
  if (!conversationId || !tag?.trim()) throw new Error("Invalid tag data");
  const created = await addConversationTagApi(conversationId, tag.trim());
  return { success: true, data: { id: created.id, conversationId, name: created.name } };
};

export const removeConversationTag = async (conversationId, tagId) => {
  if (!conversationId || !tagId) throw new Error("Invalid tag data");
  await removeConversationTagApi(conversationId, tagId);
  return { success: true, tagId };
};
